import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Role translation function
export function translateRole(role: string | undefined): string {
  if (!role) return 'Kullanıcı';
  
  const roleTranslations: { [key: string]: string } = {
    'Admin': 'Yönetici',
    'SchoolManager': 'Okul Müdürü',
    'SchoolUser': 'Okul Kullanıcısı',
    'ApplicationUser': 'Uygulama Kullanıcısı',
    'SystemAdmin': 'Sistem Yöneticisi',
    'Parent': 'Veli',
    'Student': 'Öğrenci'
  };
  
  return roleTranslations[role] || role;
}
